import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { useCart } from "@/contexts/CartContext";

export default function CheckoutSuccess() {
  const [sp] = useSearchParams();
  const session_id = sp.get("session_id");
  const order_id = sp.get("order_id");
  const [status, setStatus] = useState("checking");
  const { clear } = useCart();
  const polled = useRef(0);
  const cleared = useRef(false);

  useEffect(() => {
    if (!session_id) { setStatus("error"); return; }
    let stop = false;
    const poll = async () => {
      if (stop || polled.current >= 8) return;
      polled.current += 1;
      try {
        const { data } = await api.get(`/checkout/status/${session_id}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (!cleared.current) { clear(); cleared.current = true; }
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2500);
      }
    };
    poll();
    return () => { stop = true; };
  }, [session_id, clear]);

  return (
    <Layout>
      <section className="max-w-2xl mx-auto px-6 py-20 text-center">
        {status === "checking" && (
          <>
            <div className="mono text-xs uppercase tracking-[0.3em] text-[#C77E3C]">Processing</div>
            <h1 className="heading text-5xl font-black uppercase tracking-tight mt-3">Checking payment…</h1>
            <p className="text-[#555] mt-3">Hold on a moment. Don't close this page.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="mono text-xs uppercase tracking-[0.3em] text-[#C77E3C]">Confirmed</div>
            <h1 className="heading text-5xl font-black uppercase tracking-tight mt-3">Thank you.</h1>
            <p className="text-[#555] mt-3">Your order <span className="mono">{order_id}</span> is paid. Digital items are available to download from your account.</p>
            <div className="mt-8 flex justify-center gap-3">
              <Link to="/buyer" data-testid="goto-orders-btn" className="btn-primary">View my orders</Link>
              <Link to="/" className="btn-ghost">Keep shopping</Link>
            </div>
          </>
        )}
        {status === "expired" && (
          <>
            <h1 className="heading text-4xl font-bold uppercase">Session expired</h1>
            <Link to="/cart" className="btn-primary mt-6 inline-block">Try again</Link>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="heading text-4xl font-bold uppercase">Something went wrong</h1>
            <Link to="/" className="btn-primary mt-6 inline-block">Back to store</Link>
          </>
        )}
      </section>
    </Layout>
  );
}
